<template>
  <el-row>
    <el-col>
      <div class="toolbar-row">
        <div class="toolbar-search">
          <!-- <rabbey-toolbox 
                        :filterables="true" 
                        @filter-search="search = $event">
                    </rabbey-toolbox> -->
        </div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          class="new-doc-btn"
          :loading="isCreatingDocument"
          :disabled="isCreatingDocument || openAdd"
          @click="onAddDocument"
        >
          Nuevo
        </el-button>
      </div>
      <rabbey-table3
        ref="table"
        :data="documentsList"
        :columns="columns"
        :search="search"
        :actions="actions"
        :loading="loading"
        :page_Size="pageSize"
        :pageSizes="pageSizes"
        @rtable-push-action="actionHandler"
        @update-page-size="updatePageSize"
      />
    </el-col>

    <el-drawer
      :title="title"
      :visible.sync="openAdd"
      direction="rtl"
      size="29%"
      @opened="onDrawerOpened"
      @closed="onDrawerClosed"
    >
      <div
        class="flex gaps column demo-drawer__content border-myborder"
        style="padding: 20px"
      >
        <div id="div-legal">
          <CreateDocument
            class="scrollable"
            style="max-height: 800px"
            :Visible="openAdd"
            IsPersonal="false"
            ref="myDocument"
            @dialog-closed="onDialogClosed"
            @success="getTableData"
          ></CreateDocument>
        </div>
      </div>
    </el-drawer>
  </el-row>
</template>

<script>
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ArchiveDownloadLink from "@/components/functionals/ArchiveDownloadLink.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import CreateDocument from "@/components/Documents/CreateDocument.vue";

export default {
  name: "DocumentosGenerales",
  components: {
    CreateDocument
  },
  data() {
    return {
      openAdd: false,
      isCreatingDocument: false,
      title: "Agregar nuevo documento",
      search: "",
      loading: false,
      pageSize: 10,
      pageSizes: [10, 20, 50, 100, 500],
      documentsList: [],
      actions: [],
      columns: [
        {
          prop: "Id",
          label: "NO",
          width: 80,
          sortable: true
        },
        {
          prop: "NameArchive",
          label: "Nombre del archivo",
          sortable: true,
          formatter: ArchiveDownloadLink
        },
        {
          prop: "DescriptionArchive",
          label: "Descripcion",
          sortable: true
        },
        {
          prop: "CreatorName",
          label: "Creador",
          sortable: true,
          formatter: ImagePerson,
          attrs: {
            imgKey: "CreatorPhoto"
          }
        },
        {
          prop: "CreatedAt",
          label: "Fecha de creacion",
          sortable: true,
          formatter: DatetimeFormatter
        }
      ]
    };
  },
  computed: {
    IsSupervisor() {
      return this.$store?.state?.user?.user.IsSupervisor;
    }
  },
  methods: {
    actionHandler() {},
    onAddDocument() {
      if (this.isCreatingDocument || this.openAdd) return;

      this.isCreatingDocument = true;
      this.openAdd = true;
    },
    onDrawerOpened() {
      this.isCreatingDocument = false;
    },
    onDrawerClosed() {
      this.openAdd = false;
      this.isCreatingDocument = false;
    },
    onDialogClosed() {
      this.openAdd = false;
      this.isCreatingDocument = false;
    },
    getTableData() {
      this.loading = true;
      const currentUser = this.$store.state.user.user;
      const employeeId = currentUser.EmployeeId;
      const isPersonal = false;

      this.$http
        .get(
          `/api/Folder/GetMyDocuments?employeeId=${employeeId}&IsPersonal=${isPersonal}`
        )
        .then((response) => {
          this.documentsList = response.data;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    updatePageSize(value) {
      this.pageSize = value;
    }
  },
  mounted() {
    this.getTableData();
  }
};
</script>

<style scoped>
.toolbar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 12px;
}

.toolbar-search {
  flex: 1;
}

.toolbar-search :deep(.mb-10) {
  margin-bottom: 0 !important;
}

.new-doc-btn {
  height: 28px;
  padding: 0 10px;
}
</style>
